export const frontStylePmrSelector = ({frontStylePmr}) => frontStylePmr